// Frans (fr-FR), food: zelfde vorm als food.nl.ts. Tu-vorm, korte zinnen; de kioskteksten voor
// kinderen (Repas, Dans le panier).
export const foodFr = {
    nav: 'Repas',
    title: 'Repas',
    tabs: {
        shopping: 'Courses',
        recipes: 'Recettes',
        menu: 'Menu de la semaine',
        pantry: 'Réserve',
    },
    undo: 'Annuler',
    save: 'Enregistrer',
    cancel: 'Annuler',
    close: 'Fermer',
    remove: 'Supprimer',
    retry: 'Réessayer',
    errorLoad: 'Le chargement n’a pas marché. Réessaie.',
    errorSave: 'L’enregistrement n’a pas marché. Réessaie.',
    categories: {
        produce: 'Fruits et légumes',
        bakery: 'Pain et petit-déjeuner',
        dairy: 'Produits laitiers et œufs',
        meat: 'Viande et poisson',
        pantry: 'Épicerie',
        drinks: 'Boissons',
        household: 'Maison',
        other: 'Autre',
    },
    units: {
        g: 'g',
        kg: 'kg',
        ml: 'ml',
        cl: 'cl',
        dl: 'dl',
        l: 'litre',
        el: 'cuillère à soupe',
        tl: 'cuillère à café',
        kop: 'tasse',
        snuf: 'pincée',
        stuk: 'pièce',
        teen: 'gousse',
        blik: 'boîte',
        pak: 'paquet',
        zak: 'sachet',
        bos: 'botte',
        plak: 'tranche',
        fles: 'bouteille',
        doos: 'carton',
        krop: 'pied',
        pot: 'pot',
        takje: 'brin',
        handje: 'poignée',
        scheut: 'filet',
    },
    shopping: {
        addLabel: 'Qu’est-ce qu’il faut acheter ?',
        addPlaceholder: 'Par exemple 2 briques de lait',
        add: 'Ajouter',
        frequent: 'Achats fréquents',
        inBasket: 'Dans ton panier ({count})',
        clearChecked: 'Effacer les articles cochés',
        newList: 'Liste',
        newListTitle: 'Nouvelle liste',
        listName: 'Nom de la liste',
        listNameHint: 'Par exemple Marché ou Pharmacie',
        listsLabel: 'Listes de courses',
        renameList: 'Modifier la liste',
        archiveList: 'Supprimer la liste',
        listMenu: 'Plus d’options pour cette liste',
        archiveAsk: 'Supprimer la liste {name} ?',
        archiveHint: 'Son contenu part avec elle. Tu peux annuler tout de suite.',
        archivedList: 'Liste {name} supprimée',
        lastList: 'La dernière liste ne peut pas être supprimée. Donne-lui plutôt un autre nom.',
        emptyTitle: 'Tout est à la maison',
        emptyBody: 'Ajoute ici ce qu’il faut acheter ; tout le monde le voit tout de suite.',
        added: '{name} est sur la liste',
        merged: '{name} : maintenant {amount}',
        removed: '{name} supprimé',
        cleared: 'Articles cochés effacés',
        viaTablet: 'via la tablette',
        forRecipe: 'pour {title}',
        editItem: 'Modifier l’article',
        name: 'Nom',
        amount: 'Quantité',
        unit: 'Unité',
        noUnit: 'Aucune',
        note: 'Remarque',
        icon: 'Pictogramme',
        list: 'Liste',
        check: 'Cocher {name}',
        uncheck: 'Décocher {name}',
        addedBy: 'Ajouté par {name}',
    },
    recipes: {
        search: 'Chercher une recette',
        filterAll: 'Toutes',
        filterOwn: 'Les miennes',
        filterLibrary: 'Collection',
        add: 'Recette',
        newTitle: 'Nouvelle recette',
        editTitle: 'Modifier la recette',
        modeManual: 'Saisir moi-même',
        modeLink: 'Depuis un lien',
        link: 'Lien vers la recette',
        linkHint: 'Fonctionne avec les sites de recettes et avec YouTube, TikTok et Instagram.',
        fetch: 'Récupérer',
        fetching: 'Récupération de la recette…',
        name: 'Nom de la recette',
        description: 'Courte description',
        servings: 'Personnes',
        minutes: 'Minutes',
        ingredients: 'Ingrédients',
        ingredientsHint: 'Un par ligne, par exemple 500 g de viande hachée',
        steps: 'Préparation',
        stepsHint: 'Une étape par ligne',
        minutesShort: '{n} min',
        people: '{n} pers.',
        video: 'Vidéo',
        needsIngredients: 'Ajoute les ingrédients',
        noResults: 'Aucune recette trouvée',
        noResultsBody: 'Essaie un autre mot ou ajoute une recette toi-même.',
        emptyTitle: 'Pas encore de recettes',
        emptyBody: 'Ajoute ta première recette, ou récupère-en une avec un lien.',
        toMenu: 'Au menu',
        toList: 'Sur la liste',
        edit: 'Modifier',
        photo: 'Ajouter une photo',
        changePhoto: 'Autre photo',
        removePhoto: 'Retirer la photo',
        photoUploading: 'Envoi de la photo…',
        photoTooLarge: 'Cette photo est trop grande.',
        photoUnsupported: 'Ce fichier n’est pas une photo que nous pouvons utiliser.',
        archive: 'Masquer',
        archived: '{title} masquée',
        openVideo: 'Voir la vidéo',
        openSource: 'Aller sur le site',
        back: 'Toutes les recettes',
        fromLibrary: 'De la collection',
        ingredientsEmpty: 'Pas encore d’ingrédients.',
        stepsEmpty: 'Pas encore de préparation.',
        toListTitle: 'Vers la liste de courses',
        toListBody: 'Ce qui est déjà en réserve ou toujours à la maison est décoché.',
        toListDo: 'Mettre sur la liste',
        toListDone: '{count} sur {list}',
        toListMerged: '{count} sur {list}, {merged} regroupés',
        toListNothing: 'Tout est déjà sur la liste ou à la maison.',
        staple: 'toujours à la maison',
        inPantry: 'à la maison',
        pickDayTitle: 'Mettre au menu',
        pickDay: 'Choisis un jour',
        planned: '{title} est prévu {day}',
        created: '{title} ajoutée',
        imported: '{title} récupérée',
        importErrors: {
            no_recipe_found: 'Cette page ne contient pas de recette que nous pouvons lire. La saisir toi-même ?',
            blocked_address: 'Nous ne pouvons pas ouvrir ce lien.',
            invalid_url: 'Utilise un lien sécurisé (qui commence par https).',
            too_large: 'Cette page est trop grande pour être lue.',
            timeout: 'Le site n’a pas répondu à temps. Réessaie plus tard.',
            fetch_failed: 'Le site n’est pas joignable pour le moment.',
        },
        fillManually: 'Saisir moi-même',
    },
    menu: {
        week: 'Semaine {week}',
        range: '{from} – {to}',
        thisWeek: 'Cette semaine',
        prev: 'Semaine précédente',
        next: 'Semaine suivante',
        allToList: 'Tout sur la liste',
        choose: 'Choisir',
        chooseFor: 'Choisis ce qu’on mange {day}',
        dragHint: 'Fais glisser une recette sur un jour',
        tapHint: 'Touche + Choisir sous un jour',
        moreRecipes: 'Plus de recettes ({count})',
        freeSection: 'Ou autre chose, par exemple Restaurant',
        freeSave: 'Au menu',
        pickRecipe: 'Choisis une recette',
        shelf: 'Recettes',
        removeMeal: 'Retirer {title} du menu',
        removed: '{title} retiré du menu',
        moved: 'Déplacé au {day}',
        freeText: 'Ou écris autre chose',
        freePlaceholder: 'Par exemple Restaurant',
        emptyTitle: 'Rien au menu pour l’instant',
        emptyBody: 'Fais glisser une recette sur un jour.',
        today: 'aujourd’hui',
        nothingToList: 'Il n’y a pas encore de recettes au menu cette semaine.',
        servings: '{n} pers.',
    },
    pantry: {
        addLabel: 'Qu’est-ce qu’on a à la maison ?',
        addPlaceholder: 'Par exemple 1 kg de pommes de terre',
        add: 'Ajouter',
        listLabel: 'En réserve',
        removeItem: 'Retirer {name} de la réserve',
        removed: '{name} retiré de la réserve',
        suggestionsTitle: 'Qu’est-ce qu’on peut faire ?',
        allInHouse: 'Tout est à la maison',
        stillNeeded: 'Il manque : {items}',
        emptyTitle: 'Rien en réserve pour l’instant',
        emptyBody: 'Ajoute ce que tu as ; nous trouvons ce que tu peux préparer.',
        noSuggestions: 'Pas encore de recette pour laquelle tout est à la maison.',
        staples: 'Le sel, le poivre, l’huile et l’eau comptent comme toujours à la maison.',
    },
    kiosk: {
        entry: 'Repas',
        back: 'Retour',
        tonight: 'Ce soir, on mange',
        nothingPlanned: 'Rien de prévu',
        nothingPlannedBody: 'Papa ou maman choisit dans l’appli.',
        tomorrow: 'Demain',
        add: 'Ajouter',
        addTitle: 'On achète quoi ?',
        close: 'Fermer',
        added: '{name} est sur la liste',
        oops: 'Oups',
        emptyTitle: 'Tout est à la maison',
        check: '{name} : dans le panier ?',
        // UX-ronde bord: een regel in het mandje met één tik terugzetten.
        backOnList: '{name} : remettre sur la liste',
        confirm: 'Dans le panier',
        shopping: 'Courses',
        week: 'Cette semaine',
        inBasket: '{name} dans le panier',
        more: 'Plus de courses',
        alreadyOn: '{name} y était déjà',
        typeOwn: 'Écrire',
        typeLabel: 'On achète quoi ?',
        typePlaceholder: 'Par ex. confiture',
        typeAdd: 'Ajouter',
        closeTyping: 'Retour aux images',
        moreTiles: 'Plus d’images',
    },
};
//# sourceMappingURL=food.fr.js.map